import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

const raf = require('raf');

class Tab extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
        currentPath: PropTypes.string,
        handleTabChange: PropTypes.func,
    };

    handleTouchStart = e => {
        const touch = e.touches[0];

        this.startX = touch.pageX;
        this.moveX = 0;
        this.leftFlag = true;
        this.rightFlag = true;
    };

    handleTouchMove = e => {
        const { initLeft, left, maxMove } = this.state;
        const touch = e.touches[0];
        let move = 0;

        if (this.moveX >= 0 && left <= 0) {
            if (this.leftFlag) {
                this.initLeftMove = left;
                this.startLeftX = touch.pageX;

                this.leftFlag = false;
            }

            this.moveX = touch.pageX - this.startLeftX;

            move = this.initLeftMove - this.moveX / 3;
        } else if (this.moveX <= 0 && left >= maxMove) {
            if (this.rightFlag) {
                this.initRightMove = left;
                this.startRightX = touch.pageX;

                this.rightFlag = false;
            }

            this.moveX = touch.pageX - this.startRightX;

            move = this.initRightMove - this.moveX / 3;
        } else {
            this.moveX = touch.pageX - this.startX;

            move = initLeft - this.moveX;
        }

        this.setState({
            left: move,
        });
    };

    handleTouchEnd = () => {
        const { left, maxMove } = this.state;

        if (left < 0) {
            raf(this.backStep);
        } else if (left > maxMove) {
            raf(this.backStep);
        } else {
            this.setState({
                initLeft: left,
            });
        }
    };

    // 回弹
    backStep = () => {
        const { initLeft, maxMove } = this.state;
        let { left } = this.state;

        if (left < initLeft) {
            left += 10;
        } else if (left > initLeft) {
            left -= 10;
        }

        this.setState({
            left,
        });

        if (this.moveX >= 0 && left >= 0) {
            this.setState({
                left: 0,
                initLeft: 0,
            });
        } else if (this.moveX <= 0 && left <= maxMove) {
            this.setState({
                left: maxMove,
                initLeft: maxMove,
            });
        } else {
            raf(this.backStep);
        }
    };

    setLocation = translateX => {
        return 'WebKitCSSMatrix' in window
            ? `translate3d(${translateX * -1}px, 0, 0)`
            : `translate(-${translateX * -1}px, 0)`;
    };

    handleClick = searchPath => {
        this.props.handleTabChange(searchPath);
    };

    render() {
        const { content, currentPath } = this.props;

        return (
            <ul className={styles.tabs}>
                {content.map((item, index) => (
                    <li key={index}>
                        <a
                            className={currentPath === item.searchPath ? styles.current : styles.item}
                            href={item.url}
                            onClick={() => this.handleClick(item.searchPath)}>
                            {item.title}
                        </a>
                        {currentPath === item.searchPath ? <span className={styles.dot} /> : ''}
                    </li>
                ))}
            </ul>
        );
    }
}

export default Tab;
